import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as d, normalizeClass as l, createElementVNode as n } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconTriangle",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.24 1.197a1.5 1.5 0 0 1 2.06.556l3.998 6.997a1.504 1.504 0 0 1 0 1.5 1.5 1.5 0 0 1-1.297.75H2.002a1.5 1.5 0 0 1-1.31-2.249L4.69 1.753v-.001a1.5 1.5 0 0 1 .55-.556Zm.755.796a.5.5 0 0 0-.435.254v.001L1.557 9.25a.5.5 0 0 0 .438.75H10a.5.5 0 0 0 .432-.75l-.001-.002-4-7-.001-.001a.5.5 0 0 0-.435-.254Z",
  "clip-rule": "evenodd"
}, null, -1), m = [
  _
];
function u(e, f, i, p, h, a) {
  return d(), r("svg", {
    "aria-label": i.ariaLabel,
    class: l([a.iconSizeClass, "d-icon d-icon--triangle"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Triangle",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, m, 10, c);
}
const I = /* @__PURE__ */ o(s, [["render", u]]);
export {
  I as default
};
//# sourceMappingURL=triangle.js.map
